var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideoCameraIcon = function SvgVideoCameraIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.063 6.828v7.125a1.189 1.189 0 0 1-1.188 1.188H3.562a2.972 2.972 0 0 1-2.968-2.97V5.048A1.189 1.189 0 0 1 1.78 3.859h8.313a2.972 2.972 0 0 1 2.969 2.97zm5.047-1.404a.594.594 0 0 0-.592-.002l-2.969 1.696a.594.594 0 0 0-.299.516v3.732a.594.594 0 0 0 .3.516l2.968 1.696a.593.593 0 0 0 .888-.515V5.936a.593.593 0 0 0-.296-.513z",
    fill: "#000"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoCameraIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VideoCameraIcon.dd591fbf.svg";
export { ForwardRef as ReactComponent };